const demoProfiles = [1, 2];
const demoUser = ['d1d6d5a0-5064-11e9-a14e-635e0fd3bfa6', '977bc550-5069-11e9-a14e-635e0fd3bfa6'];
const salesUser = ['3f0e6520-0585-11ec-b953-af4ccf7a742b'];
const demoListings = [5, 6, 389, 801, 878, 880, 881, 882, 883, 884, 898, 899, 900, 902, 903, 912, 913, 914, 915, 917, 920, 925, 926, 927, 928, 929, 930, 931, 932, 962, 963, 1055, 1099, 1100, 1, 2, 3, 4, 943, 907, 908, 909, 910, 918, 919];
const demoPopularLocations = [1, 2, 3, 4, 5, 6, 7, 13];
const demoSMTP = [1];
const demoData = {
    email: 'demo@radicalstart.com',
    password: 'demouser'
};
const demoAdmin = {
    email: 'admin@radicalstart.com',
    password: 'qwerty123'
};

export {
    demoProfiles, demoUser, demoListings,
    demoPopularLocations, demoData, demoAdmin,
    salesUser, demoSMTP
}